import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { AdvertContactDataType } from '@edikk-edikk/country-frontend';
import { removeContactData, setContactData } from '#advertContacts/reducers';
import { UseAdvertContactsDataControlResultType } from '#advertContacts/hooks';

const useAdvertContactsDataControl = (): UseAdvertContactsDataControlResultType => {
  const dispatch = useDispatch();

  const triggerSetContactData = useCallback((contactData: AdvertContactDataType) => {
    dispatch(setContactData(contactData));
  }, [dispatch]);

  const triggerRemoveContactData = useCallback(() => {
    dispatch(removeContactData());
  }, [dispatch]);

  return {
    setContactData: triggerSetContactData,
    removeContactData: triggerRemoveContactData,
  };
};

export { useAdvertContactsDataControl };
